import React, { useEffect, useMemo, useState } from "react";
import '../../../node_modules/bootstrap/dist/css/bootstrap.min.css';
import TableContainer from '../../components/Common/TableContainer';
import * as Yup from "yup";
import { useFormik } from "formik";

//import components
import Breadcrumbs from '../../components/Common/Breadcrumb';
import DeleteModal from '../../components/Common/DeleteModal';

import {
    getInternships as onGetInternships,
    addNewInternship as onAddNewInternship,
    updateInternship as onUpdateInternship,
    deleteInternship as onDeleteInternship,

    getInternshipStructures as onGetInternshipStructures,
    getStudents as onGetStudents,
    getTeachers as onGetTeachers,
} from "store/actions";

//redux
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";

import {
    Col,
    Row,
    UncontrolledTooltip,
    Modal,
    ModalHeader,
    ModalBody,
    Form,
    Input,
    FormFeedback,
    Label,
    Card,
    CardBody,
    UncontrolledDropdown,
    DropdownToggle,
    DropdownMenu,
    DropdownItem,
    Badge,
    Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { Link } from "react-router-dom";

const Internship = () => {

    //meta title
    document.title = "Stages | CinzanEdu";

    const [modal, setModal] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [internship, setInternship] = useState(null);
    


 

    // validation
    const validation = useFormik({
        // enableReinitialize : use this flag when initial values needs to be changed
        enableReinitialize: true,

        initialValues: {
            uid: (internship && internship.uid) || '',
            student_id: (internship && internship.student_id) || '',
            structure_id: (internship && internship.structure_id) || '',
            teacher_id: (internship && internship.teacher_id) || '',
            duration: (internship && internship.duration) || '',
            rapport_url: (internship && internship.rapport_url) || '',
            status: (internship && internship.status) || '',
            
        },
        validationSchema: Yup.object({
           
            student_id: Yup.number().required("Veuillez sélectionner l'étudiant"),
            structure_id: Yup.number().required("Veuillez sélectionner la structure"),
            teacher_id: Yup.number().required("Veuillez sélectionner le professeur"),
            duration: Yup.number().required("Veuillez saisir la durée"),
            rapport_url: Yup.string().required("Veuillez saisir l'url du rapport'"),
            status: Yup.string().required("Veuillez sélectionner le statut'"),
            
  
        }),
        onSubmit: (values) => {
            if (isEdit) {
                //const payload = { series_category: values }
                const internship = {
                    //id: values.id,
                    uid: values.uid,
                    student_id: values.student_id,
                    structure_id: values.structure_id,
                    teacher_id: values.teacher_id,
                    duration: values.duration,
                    rapport_url: values.rapport_url,
                    status: values.status,
                    
                };
           
                dispatch(onUpdateInternship(internship));
                validation.resetForm();
            } else {
                const newInternship = {
                    //id: values["id"],
                    //uid: values["uid"],
                   
                    student_id: values["student_id"],
                    structure_id: values["structure_id"],
                    teacher_id: values["teacher_id"],
                    duration: values["duration"],
                    rapport_url: values["rapport_url"],
                    status: values["status"],
                   
                };
        
                dispatch(onAddNewInternship(newInternship));
                validation.resetForm();
            }
            toggle();
        },
    });

    const dispatch = useDispatch();

    const InternshipProperties = createSelector(
        (state) => state.internshipReducer, 
        (internshipReducer) => ({
            internships: internshipReducer.internships,
            loading: internshipReducer.loading
        })
    );

    const {internships, loading} = useSelector(InternshipProperties);

    const [isLoading, setLoading] = useState(loading)


   

     // Students
    const StudentProperties = createSelector(
        (state) => state.studentReducer, 
        (studentReducer) => ({
            students: studentReducer.students,
            loading: studentReducer.loading
        })
    );

    const {students} = useSelector(StudentProperties);

      // Structures
    const StructureProperties = createSelector(
        (state) => state.structureReducer, 
        (structureReducer) => ({
            structures: structureReducer.structures,
            loading: structureReducer.loading
        })
    );

    const {structures} = useSelector(StructureProperties);



    // Teachers
    const TeacherProperties = createSelector(
        (state) => state.teacherReducer, 
        (teacherReducer) => ({
            teachers: teacherReducer.teachers,
            loading: teacherReducer.loading
        })
    );

    const {teachers} = useSelector(TeacherProperties);
    

    

    useEffect(() => {
        if (internships && !internships.length) {
            dispatch(onGetInternships());
        }

        if (structures && !structures.length) {
            dispatch(onGetInternshipStructures());
        }

        if (students && !students.length) {
            dispatch(onGetStudents());
        }

         if (teachers && !teachers.length) {
            dispatch(onGetTeachers());
        }
    }, [dispatch, internships.length, structures.length, students.length, teachers.length]);



   


    

  

    const toggle = () => {
        if (modal) {
            setModal(false);
            setInternship(null);
        } else {
            setModal(true);
        }
    };

    const handleInternshipClick = arg => {
        const internship = arg;
        setInternship({
            id: internship.id,
            uid: internship.uid,
            student_id: internship.student_id,
            structure_id: internship.structure_id,
            teacher_id: internship.teacher_id,
            duration: internship.duration,
            rapport_url: internship.rapport_url,
            status: internship.status,
           
        });


        // Set for update url
        setIsEdit(true);

        toggle();
    };

    //delete Serial movie
    const [deleteModal, setDeleteModal] = useState(false);

    const onClickDelete = (internship) => {
        setInternship(internship);
        setDeleteModal(true);
    };

    const handleDeleteInternship = () => {
        if (internship && internship.id) {
            dispatch(onDeleteInternship(internship));
            setDeleteModal(false);
        }
    };

    const onClickNewInternship = () => {
        setIsEdit(false);
        setInternship(null);
        toggle();
        //setModal(true)
    };

    const columns = useMemo(
        () => [
            {
                header: 'ID',
                accessorKey: "id",
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return <Link to="#" className="text-body fw-bold">{cellProps.row.original.id}</Link>
                }
            },
            {
                header: "Étudiant",
                accessorKey: "student.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Structure",
                accessorKey: "structure.name",
                enableColumnFilter: false,
                enableSorting: true,
            },
            {
                header: "Professeur",
                accessorKey: "teacher.id",
                enableColumnFilter: false,
                enableSorting: true,
            },

             {
                header: "Durée",
                accessorKey: "duration",
                enableColumnFilter: false,
                enableSorting: true,
            },

             {
                header: "État",
                accessorKey: "status",
                enableColumnFilter: false,
                enableSorting: true,
            },

            
            
            
            {
                header: 'Action',
                enableColumnFilter: false,
                enableSorting: true,
                cell: (cellProps) => {
                    return (
                        <ul className="list-unstyled hstack gap-1 mb-0">
                            
                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-info"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        handleInternshipClick(jobData);
                                    }}
                                    id={`edittooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-pencil-outline" />
                                    <UncontrolledTooltip placement="top" target={`edittooltip-${cellProps.row.original.id}`} >
                                        Edit
                                    </UncontrolledTooltip>
                                </Link>
                            </li>

                            <li>
                                <Link
                                    to="#"
                                    className="btn btn-sm btn-soft-danger"
                                    onClick={() => {
                                        const jobData = cellProps.row.original;
                                        //console.log("ON DELETE: ", jobData);
                                        onClickDelete(jobData);
                                    }}
                                    id={`deletetooltip-${cellProps.row.original.id}`}
                                >
                                    <i className="mdi mdi-delete-outline" />
                                    <UncontrolledTooltip placement="top" target={`deletetooltip-${cellProps.row.original.id}`}>
                                        Delete
                                    </UncontrolledTooltip>
                                </Link>
                            </li>
                        </ul>
                    );
                }
            },
        ],
        []
    );

    return (
        <React.Fragment>
            <DeleteModal
                show={deleteModal}
                onDeleteClick={handleDeleteInternship}
                onCloseClick={() => setDeleteModal(false)}
            />
            <div className="page-content">
                <div className="container-fluid">
                    <Breadcrumbs title="Stages" breadcrumbItem="Liste des stages" />
                    {
                        isLoading ? <Spinners setLoading={setLoading} />
                            :
                            <Row>
                                <Col lg="12">
                                    <Card>
                                        <CardBody className="border-bottom">
                                            <div className="d-flex align-items-center">
                                                <h5 className="mb-0 card-title flex-grow-1"></h5> 
                                                <div className="flex-shrink-0">
                                                    <Link to="#!" onClick={onClickNewInternship} className="btn btn-primary me-1">Ajouter un stage</Link>
                                                    
                                                </div>
                                            </div>
                                        </CardBody>
                                        <CardBody>
                                            <TableContainer
                                                columns={columns}
                                                data={internships || []}
                                                isCustomPageSize={true}
                                                isGlobalFilter={true}
                                                //isJobListGlobalFilter={false}
                                                isPagination={true}
                                                SearchPlaceholder="Rechercher ..."
                                                tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline"
                                                theadClass="table-light"
                      
                        
                                                
                                                //tableClass="align-middle table-nowrap dt-responsive nowrap w-100 table-check dataTable no-footer dtr-inline mt-4 border-top"
                                                pagination="pagination"
                                                paginationWrapper="dataTables_paginate paging_simple_numbers pagination-rounded"
                                            />
                                        </CardBody>
                                    </Card>
                                </Col>
                            </Row>
                    }
                    <Modal 
                        isOpen={modal} 
                        toggle={toggle}
                         backdrop={'static'}
                            id="staticBackdrop"
                    >
                        <ModalHeader toggle={toggle} tag="h4">
                            {!!isEdit ? "Modifier - Stage" : "Ajouter - Stage"}
                        </ModalHeader>
                        <ModalBody>
                            <Form
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    validation.handleSubmit();
                                    return false;
                                }}
                            >
                                <Row>
                                    <Col className="col-12">
                                       

                                       

                                        <div className="mb-3">
                                            <Label>Structure</Label>
                                            <Input
                                                name="structure_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.structure_id || ""
                                                }
                                                invalid={
                                                    validation.touched.structure_id && validation.errors.structure_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {structures.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.structure_id && validation.errors.structure_id ? (
                                                <FormFeedback type="invalid">{validation.errors.structure_id}</FormFeedback>
                                            ) : null}
                                        </div>


                                        <div className="mb-3">
                                            <Label>Étudiant</Label>
                                            <Input
                                                name="student_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.student_id || ""
                                                }
                                                invalid={
                                                    validation.touched.student_id && validation.errors.student_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {students.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.student_id && validation.errors.student_id ? (
                                                <FormFeedback type="invalid">{validation.errors.student_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Professeur</Label>
                                            <Input
                                                name="teacher_id"
                                                type="select"
                                                className="form-select"
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={
                                                    validation.values.teacher_id || ""
                                                }
                                                invalid={
                                                    validation.touched.teacher_id && validation.errors.teacher_id
                                                        ? true
                                                        : false
                                                }
                                            >
                                                <option value="">-- Sélectionner --</option>
                                                    {teachers.map((c) => (
                                                    <option key={c.id} value={c.id}>{c.name}</option>
                                                    ))}

                                            </Input>
                                            {validation.touched.teacher_id && validation.errors.teacher_id ? (
                                                <FormFeedback type="invalid">{validation.errors.teacher_id}</FormFeedback>
                                            ) : null}
                                        </div>

                                        <div className="mb-3">
                                            <Label>Durée</Label>
                                            <Input
                                                name="duration"
                                                type="numeric"
                                                placeholder="Durée"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.duration || ""}
                                                invalid={
                                                    validation.touched.duration && validation.errors.duration ? true : false
                                                }
                                            />
                                            {validation.touched.duration && validation.errors.duration ? (
                                                <FormFeedback type="invalid">{validation.errors.duration}</FormFeedback>
                                            ) : null}
                                        </div>

                                         <div className="mb-3">
                                            <Label>URL rapport</Label>
                                            <Input
                                                name="rapport_url"
                                                type="text"
                                                placeholder="rapport_url"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.rapport_url || ""}
                                                invalid={
                                                    validation.touched.rapport_url && validation.errors.rapport_url ? true : false
                                                }
                                            />
                                            {validation.touched.rapport_url && validation.errors.rapport_url ? (
                                                <FormFeedback type="invalid">{validation.errors.rapport_url}</FormFeedback>
                                            ) : null}
                                        </div>

                                         <div className="mb-3">
                                            <Label>État</Label>
                                            <Input
                                                name="status"
                                                type="text"
                                                placeholder="État"
                                                validate={{
                                                    required: { value: true },
                                                }}
                                                onChange={validation.handleChange}
                                                onBlur={validation.handleBlur}
                                                value={validation.values.status || ""}
                                                invalid={
                                                    validation.touched.status && validation.errors.status ? true : false
                                                }
                                            />
                                            {validation.touched.status && validation.errors.status ? (
                                                <FormFeedback type="invalid">{validation.errors.status}</FormFeedback>
                                            ) : null}
                                        </div>
                                       
                                       
                                        
                                       

                                        

                                        
                                        
                                        
                                        
                                        
                                    </Col>
                                </Row>
                                <Row>
                                    <Col>
                                        <div className="text-end">
                                            <Button color="btn btn-primary me-1"
                                                type="submit"
                                                className="save-user"
                                            >
                                                
                                                {!!isEdit ? "Modifier " : "Enregistrer"}
                                            </Button>
                                        </div>
                                    </Col>
                                </Row>
                            </Form>
                        </ModalBody>
                    </Modal>
                </div>
            </div>
            <ToastContainer />
        </React.Fragment>
    );
}


export default Internship;